import React, { useRef, useState, forwardRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/** Utilities */
import { encryptUrlData } from "../../../../services/CryptoService";


/** Common Components */
import Buttons from "../../../../components/ui/button/Buttons";
import FormCreator from "../../../../components/finalForms/FormCreator";

/** Common Services & Data Files */
import { AppIcons } from "../../../../data/appIcons";
import ToastService from "../../../../services/toastService/ToastService";

/** Configuration Files */
import { teamPlanning } from "../teamPlanning/config/TeamPlanning.data";

/** RTK Query */
import { useAddTeamPlanningMutation } from "../../../../app/services/teamPlanningAPI";

/** Lazily Loaded Components */
import PlanningTeamMembers from "../planningTeamMembers/PlanningTeamMembers";

const AddEditTeamPlanning = forwardRef((props, ref) => {

  const teamPlanningRef = useRef();
  /* State*/
  const [step, setStep] = useState(1);
  const [planningId, setPlanningId] = useState(null);
  const [teamPlanningForm, setTeamPlanningForm] = useState(teamPlanning);

  const navigate = useNavigate();
  const location = useLocation();

  const teamId = props.teamId;
  const teamName = props.teamName;
  // API'S Call
  const [addTeamPlanning, {isSuccess: isTeamPlannningAdded,isLoading: isTeamPlanningAdding,data: TeamPlanningData,},] = useAddTeamPlanningMutation();

   //** Funcation's */
  const calculateWorkingDays = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    let workingDays = 0;
    for (let currentDate = new Date(start); currentDate <= end; currentDate.setDate(currentDate.getDate() + 1)) {
      const dayOfWeek = currentDate.getDay();
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        workingDays++;
      }
    }

    return workingDays;
  };

  const handleColumnChange = (fieldName, updatedformData) => {
    if (updatedformData) {
      const { startDate, endDate } = updatedformData;
      if ((fieldName === "startDate" || fieldName === "endDate") && startDate && endDate) {
        const workingDays = calculateWorkingDays(startDate, endDate);
        let updatedForm = {
          ...teamPlanningForm,
          initialState: {
            ...updatedformData, workingDays: workingDays
          },
        };

        setTeamPlanningForm(updatedForm);
      }
    }
  };

  const handleNextStep = () => {
    let FormData = teamPlanningRef.current.getFormData();
    if (FormData) {
      const requestData = {
        ...FormData,
        teamId: teamId,
        planningTitle: FormData.planningTitle,
        startDate: FormData.startDate,
        endDate: FormData.endDate,
        workingDays: FormData.workingDays,
      };
      if (FormData.startDate && FormData.endDate && FormData.workingDays) {
        addTeamPlanning(requestData);
      }
    }
  };


  const handleCreate = () => {
    backToList();
    if (props.onGridRefresh) {
      props.onGridRefresh();
    }
    let dataURL = {};
    dataURL.teamId = teamId;
    dataURL.teamName = teamName;
    dataURL.planningId = planningId;
    const encryptedData = encryptUrlData(dataURL);
    const basePath = location.pathname.includes("/admin/teams/")
      ? "/admin/teams/TeamPlanning/"
      : "/myteams/TeamPlanning/";
    navigate(`${basePath}${encryptedData}`);
  }

  const handleCloseandNext = () => {
    let dataURL = {};
    dataURL.planningId = planningId;
    dataURL.teamId = teamId;
    dataURL.startDate = teamPlanningForm.initialState.startDate;
    dataURL.endDate = teamPlanningForm.initialState.endDate;
    dataURL.workingDays = teamPlanningForm.initialState.workingDays;
    dataURL.teamName = teamName;
    const encryptedData = encryptUrlData(dataURL);
    const basePath = location.pathname.includes("/admin/teams/")
      ? "/admin/teams/taskplan/"
      : "/myteams/taskplan/";
    navigate(`${basePath}${encryptedData}`);
  }

  const handleBackStep = () => {
    setStep(1);
  };
  
  //** useEffect's */

  useEffect(() => {
    if (isTeamPlannningAdded && TeamPlanningData) {
      if (TeamPlanningData.errorMessage.includes("exists")) {
        ToastService.warning(TeamPlanningData.errorMessage);
        return;
      } else {
        ToastService.success(TeamPlanningData.errorMessage);
        setPlanningId(TeamPlanningData.keyValue)
        setStep(2);
      }
    }
  }, [isTeamPlannningAdded, TeamPlanningData]);

  const backToList = () => {
    props.onClose();
  };

  return (
    <>
      <div className="row">
        {step === 1 ? (
          <FormCreator
            config={teamPlanningForm}
            onColumnChange={handleColumnChange}
            ref={teamPlanningRef}
            {...teamPlanningForm}
          />
        ) : (
          <div>
            <PlanningTeamMembers planningId={planningId} teamId={teamId} />
          </div>
        )}
      </div>
      <div className="row mt-3">
        <div className="col-12">
          <div className="form-btn d-flex justify-content-end">
            {step === 2 && (
              <Buttons
                buttonTypeClassName="dark-btn"
                onClick={handleBackStep}
                buttonText="Back"
              />
            )}
            {step === 1 ? (
              <Buttons
                buttonTypeClassName="theme-btn ml-4"
                buttonText="Next"
                onClick={handleNextStep}
                isLoading={isTeamPlanningAdding}
              />
            ) : (
              <>
                <Buttons
                  buttonTypeClassName="theme-btn ml-4"
                  imagePath={AppIcons.AddIcon}
                  buttonText="Create"
                  onClick={handleCreate}
                />
                <Buttons
                  buttonTypeClassName="theme-btn ml-4"
                  imagePath={AppIcons.AddIcon}
                  buttonText="Create & Continue"
                  onClick={handleCloseandNext}
                />
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
});

export default AddEditTeamPlanning;
